/* eslint-disable */
import Vue from 'vue';
import { sync } from 'vuex-router-sync';

import ShardsVue from 'shards-vue';

// Styles
import 'bootstrap/dist/css/bootstrap.css';
import '@/assets/scss/shards-dashboards.scss';
import '@/assets/scss/date-range.scss';
import '@/assets/fonts/fonts.scss';

// Core
import App from './App.vue';
import store from './store';
import router from './router'


ShardsVue.install(Vue);

Vue.config.productionTip = false;
Vue.prototype.$eventHub = new Vue();

// shards-vue popovers/tooltips may call getBoundingClientRect on a detached node
// under Vue 2.7 + Webpack 5; swallow that known NPE so it does not blank the UI.
Vue.config.errorHandler = (err, vm, info) => {
  if (err && /getBoundingClientRect/.test(String(err.message || err))) {
    return;
  }
  // eslint-disable-next-line no-console
  console.error(`[Vue error] ${info}:`, err);
};

sync(store, router);

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app');
